import ServiceHelper from "./service.helper";

export default class AccountService {
    static BASE_URL = '/auth';

    static createVirtualAccount(payload) {
        return ServiceHelper.handlePostRequest(`/virtual_account/`, payload);
    }

    static getVirtualAccounts() {
        return ServiceHelper.handleGetRequest('/virtual_account')
    }

    static getAccounts() {
        return ServiceHelper.handleGetRequest('/accounts')
    }

    static getBankList() {
        return ServiceHelper.handleGetRequest(`/add_bank/?action=get_banks`);
    }

    static getCountries() {
        return ServiceHelper.handleGetRequest(`/country_list/`);
    }

    static verifyBvn(bvn, dob) {
        return ServiceHelper.handleGetRequest(`/verify_bvn/?bvn=${bvn}&dob=${dob}`);
    }
    
    static validateAccountNumber(payload) {
        return ServiceHelper.handleGetRequest(`/add_bank/?action=validate&code=${payload.code}&account_number=${payload.account_number}`);
    }
    
    static createPaycode(payload){
        return ServiceHelper.handlePostRequest('/create_paycode/', payload);
    }
    
    
    static createQrPaycode(payload){
        const merchant_id = payload.merchant_id
        delete payload['merchant_id']
        return ServiceHelper.handlePostRequest(`/create_paycode/${merchant_id}`, payload);
    }
    
    static bulkCreatePaycode(payload){
        return ServiceHelper.handlePostRequest('/create_bulk_paycode/', payload);
    }

    static checkPaycodeBalance(payload) {
        return ServiceHelper.handleGetRequest(`/paycode_balance/?token=${payload.paycode}&secret=${payload.secret_word}`);
    }
     
    static confirmPaycode(payload){
        return ServiceHelper.handlePostRequest('/confirm_paycode/', payload);
    }

    // static getMerchantPaycode(params){
    //     return ServiceHelper.handleGetRequest(`/paycodes/?page=${param}`);
    // }

    static getMerchantPaycode(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.status !== '' && params.status !== undefined) {
            request_params += `&status=${params.status}`;
        }
        if(params.filter !== '' && params.filter !== undefined) {
            request_params += `&filter=${params.filter}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined) {
            request_params += `&filter_by=${params.filter_by}`;
        }
        if(params.sort_by !== '' && params.sort_by !== undefined) {
            request_params += `&sort_by=${params.sort_by}`;
        }
        if(params.download !== '' && params.download !== undefined && params.download === 'True') {
            request_params += `&download=${params.download}`;
        }
        if(params.gateway !== '' && params.gateway !== undefined) {
            request_params += `&gateway=${params.gateway}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }
        request_params = request_params.slice(1)
        return ServiceHelper.handleGetRequest(`/paycodes/?${request_params}`);
    }

    static claimPaycode(payload){
        return ServiceHelper.handlePostRequest('/claim_paycode/', payload);
    }

    static claimPaycodeWithQr(payload){
        return ServiceHelper.handlePostRequest('/api-v1/claim_paycode/', payload);
    }

    static applyPaycode(payload){
        return ServiceHelper.handlePostRequest('/paycode/redeem/', payload);
    }

    static addAccountDetails(payload) {
        return ServiceHelper.handlePostRequest('/add_bank/', payload);
    }

    static transactionHistory(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.filter_by === 'type'){
            request_params += `&transaction_type=${params.filter}`;
        }
        if(params.status !== '' && params.status !== undefined) {
            request_params += `&status=${params.status}`;
        }
        if(params.filter !== '' && params.filter !== undefined) {
            request_params += `&filter=${params.filter}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined) {
            request_params += `&filter_by=${params.filter_by}`;
        }
        if(params.sort_by !== '' && params.sort_by !== undefined) {
            request_params += `&sort_by=${params.sort_by}`;
        }
        if(params.download !== '' && params.download !== undefined && params.download === 'True') {
            request_params += `&download=${params.download}`;
        }
        if(params.gateway !== '' && params.gateway !== undefined) {
            request_params += `&gateway=${params.gateway}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }
        // if(params.download !== '' && params.download === true) {
        //     request_params += `&download=True`;
        // }
        request_params = request_params.slice(1)
        if(params.download === 'True') {
            return ServiceHelper.handleDownloadRequest(`/transaction_history/?${request_params}`, 'Transaction_History');
        }
        return ServiceHelper.handleGetRequest(`/transaction_history/?${request_params}`);
    }

    static generateReport(params) {
        let request_params = ``;

        if(params.from_date !== '') {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== ''){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.status !== '' && params.status !== 'all') {
            request_params += `&status=${params.status}`;
        }
        if(params.transaction_type !== '' && params.transaction_type !== 'all') {
            request_params += `&transaction_type=${params.transaction_type}`;
        }
        if(params.reference !== '') {
            request_params += `&reference=${params.reference}`;
        }
        if(params.download !== '' && params.download === 'True') {
            request_params += `&download=${params.download}`;
        }
        if(params.page !== '') {
            request_params += `&page=${params.page}`;
        }
        if(params.gateway !== '') {
            request_params += `&gateway=${params.gateway}`;
        }
        request_params = request_params.slice(1)
        if(params.download === 'True') {
            return ServiceHelper.handleDownloadRequest(`/transaction_history/?${request_params}`, 'Transactions_History');
        }
        return ServiceHelper.handleGetRequest(`/transaction_history/?${request_params}`);
    }

    static getInvoices(param = 1) {
        return ServiceHelper.handleGetRequest(`/merchant_invoice/?page=${param}`);
    }

    static getInvoicesByRef(ref) {
        return ServiceHelper.handleGetRequest(`/merchant_invoice/?ref=${ref}`);
    }
    
    static createInvoice(payload) {
        return ServiceHelper.handlePostRequest(`/merchant_invoice/`, payload);
    }
    
    static invoicePayment(payload) {
        return ServiceHelper.handlePostRequest(`/pay_invoice/${payload.invoice_id}/`, payload);
    }

    static updateInvoiceData(payload) {
        return ServiceHelper.handlePutRequest(`/update_invoice/${payload.ref}/`, {
            amount: payload.amount,
            description: payload.description,
            email: payload.email,
            phone: payload.phone,
            customer_name: payload.customer_name
        });
    }

    static deleteInvoiceData(reference) {
        return ServiceHelper.handleDeleteRequest(`/update_invoice/${reference}/`);
    }

    static getVouchers() {
        return ServiceHelper.handleGetRequest(`/user_vouchers/`);
    }

    static getCharges() {
        return ServiceHelper.handleGetRequest("/transaction_charges/");
      }
    
    static analytics(params) {
        let url = "/dashboard_analytics/"
        if(params.type !== 'day' && params.type !=='month') {
            url = "/dashboard_analytics/?type="+params.type
        }
        if(params.type ==='month') {
            url = `/dashboard_analytics/?filter_type=${params.type}&filter_year=${params.filter_year}`
        }
        else if(params.type === 'day' && params.date !== undefined && params.date !== undefined) { 
            url = `/dashboard_analytics/?type=${params.type}&date=${params.date}`
        }
        return ServiceHelper.handleGetRequest(url);
    }
    
    static verifyInvoice(payload) {
        return ServiceHelper.handlePostRequest("/verify_invoice/", payload);
    }
    
    static announcements() {
        return ServiceHelper.handleGetRequest("/announcements/");
    }
    
    static uploadContactList(payload) {
        if(payload.user_type === 'owner') {
            return ServiceHelper.handlePostRequest("/contact_upload/", payload.contactlist);
        } else {
            return ServiceHelper.handlePostRequest("/members/contact_upload/", payload.contactlist);
        }
    }

    static fasePay(payload){
        return ServiceHelper.handlePostRequest('/fase_pay/', payload);
    } 
    
    static faasPayCodeDetails(paycode){
        return ServiceHelper.handleGetRequest(`/fase_pay/?paycode=${paycode}`);
    } 

    static sellFx(payload){
        return ServiceHelper.handlePostRequest('/sell_fx/', payload);
    }

    static fasepayTransactions(params = 1) {
        return ServiceHelper.handleGetRequest(`/transaction_history/?gateway=FasePay&page=${params}`);
    }
    
    static getFxRates(){
        return ServiceHelper.handleGetRequest('/sell_fx/');
    }
    
    static chargeAccount(payload){
        return ServiceHelper.handlePostRequest('/api-v1/side_brief_webhook/', payload);
    }

    static getInflowData(){
        return ServiceHelper.handleGetRequest('/inflow_data/');
    }

    static getTaxCalculators(params) {
        let uri =  `/tax`;
        if(params.filter_year !== '' && params.filter_year !== undefined && params.filter_month !== '' && params.filter_month !== undefined) {
            uri = `/tax/?filter_year=${params.filter_year}&filter_month=${params.filter_month}`;
        }
        return ServiceHelper.handleGetRequest(`${uri}`);
    }

    static createLoyaltyPaycode(payload){
        return ServiceHelper.handlePostRequest('/loyalty_voucher/', payload);
    }

    static createBulkLoyaltyVoucher(payload){
        return ServiceHelper.handlePostRequest(`/loyalty_voucher_bulk_create/`, payload);
    }
    
    static createLoyaltyQrPaycode(payload){
        delete payload['merchant_id']
        return ServiceHelper.handlePostRequest(`/loyalty_voucher/${payload.merchant_id}`, payload);
    }

    static checkLoyaltyPaycodeBalance(payload) {
        if(payload.user_type === 'owner') {
            return ServiceHelper.handleGetRequest(`/loyalty_voucher_balance/?code=${payload.paycode}&secret=${payload.secret_word}`);
        }
        return ServiceHelper.handleGetRequest(`/members/loyalty_voucher_balance/?code=${payload.paycode}&secret=${payload.secret_word}`);
    }
     
    static confirmLoyaltyPaycode(payload){
        return ServiceHelper.handlePostRequest('/confirm_paycode/', payload);
    }

    static claimLoyaltyPaycode(payload){
        return ServiceHelper.handlePutRequest('/loyalty_voucher/', payload);
    }

    static setVoucherDiscount(payload){
        return ServiceHelper.handlePostRequest('/loyalty_voucher_discount/', payload);
    }

    static getVoucherDiscount(){
        return ServiceHelper.handleGetRequest('/loyalty_voucher_discount/');
    }

    // static getLoyaltyPaycodes(payload){
    //     return ServiceHelper.handleGetRequest('/loyalty_voucher/', payload);
    // }

    static getLoyaltyPaycodes(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined && params.from_date === '') {
            request_params += `&filter_by=${params.filter}`;
        }
        if(params.paycode_id !== '' && params.paycode_id !== undefined) {
            request_params += `&paycode_id=${params.paycode_id}`;
        }
        request_params = request_params.slice(1)
        if(params.user_type === 'owner') {
            return ServiceHelper.handleGetRequest(`/loyalty_voucher/?${request_params}`);
        }
        return ServiceHelper.handleGetRequest(`/members/loyalty_voucher/?${request_params}`);
    }

    static getLoyaltyPaycodeHistory(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined && params.from_date === '') {
            request_params += `&filter_by=${params.filter}`;
        }
        if(params.paycode_id !== '' && params.paycode_id !== undefined) {
            request_params += `&paycode_id=${params.paycode_id}`;
        }
        request_params = request_params.slice(1)
        if(params.user_type === 'owner') {
            return ServiceHelper.handleGetRequest(`/loyalty_voucher_history/?${request_params}`);
        }
        return ServiceHelper.handleGetRequest(`/members/loyalty_voucher_history/?${request_params}`);
    }

    static sendOtp(user_type){
        if(user_type === 'owner') {
            return ServiceHelper.handleGetRequest('/loyalty_voucher_verification/');
        }
        return ServiceHelper.handleGetRequest('/members/loyalty_voucher_verification/');
    }

    static requestOTP(){
        return ServiceHelper.handleGetRequest('/request_otp/');
    }

    static topupVoucher(payload){
        return ServiceHelper.handlePostRequest('/loyalty_voucher_topup/', payload);
    }


    // ****************************** Petty Cash *******************************
    static getPettyCashWalletDetails() {
        return ServiceHelper.handleGetRequest(`/petty_cash_wallet/`);
    }

    static creditPettyCashWallet(payload) {
        return ServiceHelper.handlePostRequest(`/petty_cash_wallet/`, payload);
    }

    static getPettyCashWalletLogs(params = {}) {

        const queryParams = new URLSearchParams();
        
        if (params.from_date && params.filter_by !== 'all') {
            queryParams.append('from_date', params.from_date);
        }
        if (params.to_date && params.filter_by !== 'all') {
            queryParams.append('to_date', params.to_date);
        }
        if (params.page) {
            queryParams.append('page', params.page);
        }
        if (params.download) {
            queryParams.append('download', params.download);
        }
        if (params.filter_by && params.filter && params.filter_by !== 'date') {
            queryParams.append('filter', 'transaction_type');
            queryParams.append('filter_value', params.filter);
        }
        
        const url = `/petty_cash_log/?${queryParams.toString()}`;

        if(params.download) {
            return ServiceHelper.handleDownloadRequest(url, 'PettyCash_Data')
        }
        
        return ServiceHelper.handleGetRequest(url);
    }

    static getPettyCashBeneficaries() {
        return ServiceHelper.handleGetRequest(`/merchant_beneficiary/`);
    }

    static createPettyCashBeneficary(payload) {
        return ServiceHelper.handlePostRequest(`/merchant_beneficiary/`, payload);
    }

    static payPettyCashBeneficary(payload) {
        return ServiceHelper.handlePostRequest(`/pay_beneficiary/`, payload);
    }

    static managePettyCashRequest(payload) {
        return ServiceHelper.handlePostRequest(`/petty_cash_request/`, payload);
    }

    static getPettyCashRequests() {
        return ServiceHelper.handleGetRequest(`/petty_cash_request/`);
    }

    static async downloadPettyCashLog() {
        return ServiceHelper.handleDownloadRequest(`/petty_cash_log/?download=${true}`, 'PettyCash_Data');
    }

    static getSalesForeceList(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.filter_by === 'type'){
            request_params += `&transaction_type=${params.filter}`;
        }
        if(params.status !== '' && params.status !== undefined) {
            request_params += `&status=${params.status}`;
        }
        if(params.filter !== '' && params.filter !== undefined) {
            request_params += `&filter_data=${params.filter}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined) {
            request_params += `&filter=${params.filter_by}`;
        }
        if(params.sort_by !== '' && params.sort_by !== undefined) {
            request_params += `&sort_by=${params.sort_by}`;
        }
        if(params.download !== '' && params.download !== undefined && params.download === 'True') {
            request_params += `&download=${params.download}`;
        }
        if(params.gateway !== '' && params.gateway !== undefined) {
            request_params += `&gateway=${params.gateway}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }

        request_params = request_params.slice(1)
        if(params.download === 'True') {
            return ServiceHelper.handleDownloadRequest(`/sales-force/merchant_sales_force/?${request_params}`, 'Salesforce_Data');
        }
        return ServiceHelper.handleGetRequest(`/sales-force/merchant_sales_force/?${request_params}`);
    }

    static getSalesForeceTransactionList(params) {
        let requestParamsObj = {
            from_date: params.from_date,
            to_date: params.to_date,
            status: params.status,
            filter: params.filter,
            page: params.page,
            filter_by: params.filter_by,
            sort_by: params.sort_by,
            transaction_type: params.transaction_type,
            sales_force_id: params.sales_force_id,
          };
          
          let query = Object.entries(requestParamsObj)
            .filter(([_, value]) => value && value !== 'undefined' && value !== '')
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&');
        
        if(params.download === 'True') {
            return ServiceHelper.handleDownloadRequest(`/sales-force/transaction_history_download/?${query}`, 'Salesforce_Transactions');
        }
        return ServiceHelper.handleGetRequest(`/sales-force/merchant_sales_force_transactions/?${query}`);
    }

    static getSalesForeceById(id) {
        return ServiceHelper.handleGetRequest(`/sales-force/sales_force_details/?sales_force_id=${id}`);
    }

    static withdrawSalesForeceBalance(payload) {
        return ServiceHelper.handlePostRequest(`/sales-force/withdraw_sales_force_balance/`, payload);
    }

    static paySalesForeceSalaries(payload) {
        return ServiceHelper.handlePostRequest(`/sales-force/pay_salary/`, payload);
    }

    
    static manageSalesForeceAgent(payload) {
        if(payload.action === 'delete') {
            delete payload.action
            return ServiceHelper.handleDeleteRequest(`/sales-force/sales_force_delete/${payload.sales_force_id}`);
        }
        return ServiceHelper.handlePostRequest(`/sales-force/block_sales_force/`, payload);
    }
    
    static getSalesForceAnalytics() {
        return ServiceHelper.handleGetRequest(`/sales-force/transaction_history_analytics/`);
    }

    // salesforce manager
    static getMemberSalesForeceList(params) {
        let request_params = ``;

        if(params.from_date !== '' && params.from_date !== undefined) {
            request_params += `&from_date=${params.from_date}`; 
        }
        if(params.to_date !== '' && params.to_date !== undefined){
            request_params += `&to_date=${params.to_date}`;
        }
        if(params.filter_by === 'type'){
            request_params += `&transaction_type=${params.filter}`;
        }
        if(params.status !== '' && params.status !== undefined) {
            request_params += `&status=${params.status}`;
        }
        if(params.filter !== '' && params.filter !== undefined) {
            request_params += `&filter_data=${params.filter}`;
        }
        if(params.filter_by !== '' && params.filter_by !== undefined) {
            request_params += `&filter=${params.filter_by}`;
        }
        if(params.sort_by !== '' && params.sort_by !== undefined) {
            request_params += `&sort_by=${params.sort_by}`;
        }
        if(params.download !== '' && params.download !== undefined && params.download === 'True') {
            request_params += `&download=${params.download}`;
        }
        if(params.gateway !== '' && params.gateway !== undefined) {
            request_params += `&gateway=${params.gateway}`;
        }
        if(params.page !== '' && params.page !== undefined) {
            request_params += `&page=${params.page}`;
        }

        request_params = request_params.slice(1)
        if(params.download === 'True') {
            return ServiceHelper.handleDownloadRequest(`/members/merchant_sales_force/?${request_params}`, 'Salesforce_Data');
        }
        return ServiceHelper.handleGetRequest(`/members/merchant_sales_force/?${request_params}`);
    }

    static getMemberSalesForeceTransactionList(params) {
        let requestParamsObj = {
            from_date: params.from_date,
            to_date: params.to_date,
            status: params.status,
            filter: params.filter,
            page: params.page,
            filter_by: params.filter_by,
            sort_by: params.sort_by,
            transaction_type: params.transaction_type,
            sales_force_id: params.sales_force_id,
          };
          
          let query = Object.entries(requestParamsObj)
            .filter(([_, value]) => value && value !== 'undefined' && value !== '')
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&');
        
        if(params.download === 'True') {
            return ServiceHelper.handleDownloadRequest(`/members/transaction_history_download/?${query}`, 'Salesforce_Transactions');
        }
        return ServiceHelper.handleGetRequest(`/members/merchant_sales_force_transactions/?${query}`);
    }

    static getMemberSalesForeceById(id) {
        return ServiceHelper.handleGetRequest(`/members/sales_force_details/?sales_force_id=${id}`);
    }

    static getMemberSalesForceAnalytics() {
        return ServiceHelper.handleGetRequest(`/members/transaction_history_analytics/`);
    }

    static getAllowedFeatures() {
        return ServiceHelper.handleGetRequest(`/allowed_features/`);
    }

    static sendPaymentRequest(payload) {
        return ServiceHelper.handlePostRequest(`/international_payments/`, payload);
    }

    static verifyPaymentRequest(merchantId) {
        return ServiceHelper.handleGetRequest(`/international_payments_status/${merchantId}/`);
    }

    static getBanks(currency) {
        return ServiceHelper.handleGetRequest(`/add_bank/?action=get_banks&currency=${currency}`);
    }
}